import * as R from "ramda";
import * as React from "react";
import styled from "styled-components";
import { courseUnitViews, fullCourseViews } from "../../../../utils/courseViews";

import AddUnitButtonWithDropTarget from "../../../course-author/tabs/preview/unit-list/AddUnitButtonWithDropTarget";
import { UnitListItemWithDropTarget } from "../../../course-author/tabs/preview/unit-list/UnitList.container";
import { CourseComponentTag, ICourseUnit } from "../../../course-author/types";
import { IUnitTreeProps } from "./types";
import { useTabIdContext } from "../../../../context/TabIdContext";

const UnitList = styled.ul`
  list-style: none;
  padding: 0;
  overflow-x: auto;
`;

const PreviewTabContent: React.SFC<IUnitTreeProps> = props => {
  const previewUnit = R.last(fullCourseViews.unitsInPath(props.course, props.unitPath));

  const unitList: ICourseUnit[] =
    (previewUnit ? courseUnitViews.subUnits(previewUnit) || [] : fullCourseViews.units(props.course)) || [];

  const displayedUnits = unitList.filter(
    unit => unit.tag === CourseComponentTag.Unit && !courseUnitViews.deleted(unit)
  );

  const { tabId: sourceTabId } = useTabIdContext();

  return (
    <UnitList>
      {displayedUnits.map(UnitListItemWithDropTarget(props, props.unitPath, sourceTabId))}
      <AddUnitButtonWithDropTarget
        dropPosition={unitList.length}
        course={props.course}
        courseId={props.courseId}
        unitPath={props.unitPath}
        editOperations={props.editOperations}
        alternateColor={!!props.alternateColor}
      />
    </UnitList>
  );
};

export default PreviewTabContent;
